var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mt-3 pt-3 mb-3 pb-3" }, [
    !_setup.state.bookings.length
      ? _c("p", [_c("em", [_vm._v("empty")])])
      : _vm._e(),
    _vm._v(" "),
    _setup.state.bookings.length
      ? _c("p", [
          _setup.courseType === "After school club" ||
          _setup.courseType === "Forest school"
            ? _c(
                "button",
                {
                  staticClass: "mb-2 btn btn-primary",
                  attrs: {
                    disabled: _setup.isButtonDisabled(false),
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      return _setup.openWorksheet(219, false, "Register")
                    },
                  },
                },
                [_vm._v("\n            Register\n        ")]
              )
            : _vm._e(),
          _vm._v(" "),
          ["Event", "Mac's Farm event", "Saplings", "Other event"].includes(
            _setup.courseType
          )
            ? _c(
                "button",
                {
                  staticClass: "mb-2 btn btn-primary",
                  attrs: {
                    disabled: _setup.isButtonDisabled(false),
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      return _setup.openWorksheet(
                        79,
                        false,
                        "Holiday Clubs registration form"
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            Holiday Clubs registration form\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "mb-2 btn btn-primary",
              class: { "btn-warning": _setup.state.parentsEmailSending },
              attrs: {
                disabled:
                  _setup.isButtonDisabled(false) ||
                  _setup.state.parentsEmailSending,
                type: "button",
              },
              on: {
                click: function ($event) {
                  return _setup.sendParentsEmail(false)
                },
              },
            },
            [_vm._v("\n            Email parents\n        ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "mb-2 btn btn-primary",
              class: { "btn-warning": _setup.state.confirmationEmailSending },
              attrs: {
                disabled:
                  _setup.isButtonDisabled(false) ||
                  _setup.state.confirmationEmailSending,
                type: "button",
              },
              on: { click: _setup.sendConfirmationEmail },
            },
            [_vm._v("\n            Confirmation email\n        ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "mb-2 btn btn-primary",
              attrs: {
                disabled: _setup.isButtonDisabled(false),
                type: "button",
              },
              on: {
                click: function ($event) {
                  return _setup.openWorksheet(136, false, "Booking table")
                },
              },
            },
            [_vm._v("\n            Open booking table\n        ")]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _setup.state.bookings.length
      ? _c("table", { staticClass: "table table-sm small" }, [
          _c("thead", [
            _c("tr", [
              _c("td", [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { checked: _setup.allCheckboxesChecked },
                  on: {
                    click: function ($event) {
                      return _setup.selectAllCheckboxes()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _c("td", [_vm._v("Child")]),
              _vm._v(" "),
              _c("td", [_vm._v("Parent")]),
              _vm._v(" "),
              _c("td", [_vm._v("Agreed price")]),
              _vm._v(" "),
              _c("td", [_vm._v("Amount paid")]),
              _vm._v(" "),
              _c("td", [_vm._v("Credit amount")]),
              _vm._v(" "),
              _c("td", [_vm._v("Payment reminder (last sent)")]),
              _vm._v(" "),
              _c("td", [_vm._v("Voucher provider")]),
              _vm._v(" "),
              _c("td", [_vm._v("Voucher payment")]),
              _vm._v(" "),
              _c("td", [_vm._v("Booking note")]),
              _vm._v(" "),
              _setup.hasArchiveAccess ? _c("td") : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_setup.state.bookings, function (booking, index) {
              return _c("tr", { key: booking.id }, [
                _c("td", [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: _setup.isChecked(booking.id) },
                    on: {
                      click: function ($event) {
                        return _setup.toggleCheckbox(booking.id)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _setup.goToBooking(booking.id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(index + 1))]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _setup.state.childNames[booking.childId]
                    ? _c("span", [
                        _c(
                          "a",
                          {
                            attrs: { href: "" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _setup.goToChild(booking.childId)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_setup.state.childNames[booking.childId])
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("td", [
                  _setup.state.parents[booking.childId]
                    ? _c("span", [
                        _c(
                          "a",
                          {
                            attrs: { href: "" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _setup.goToParent(
                                  _setup.state.parents[booking.childId].id
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _setup.state.parents[booking.childId]
                                    .firstName
                                ) +
                                " " +
                                _vm._s(
                                  _setup.state.parents[booking.childId].lastName
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          _vm._s(_setup.state.parents[booking.childId].email) +
                            "\n                    "
                        ),
                        _c("br"),
                        _vm._v(
                          _vm._s(
                            _setup.state.parents[booking.childId].telephone
                          ) + "\n                "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_setup.formatCurrency(booking.agreedPrice))),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _setup.openPaymentLogModal(booking.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_setup.formatCurrency(booking.amountPaid)) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(_setup.formatCurrency(booking.creditAmountUsed))
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  booking.placeConfirmed
                    ? _c("span", [_vm._v("Confirmed")])
                    : _setup.isNotPaid(booking.amountPaid) &&
                      !booking.franchiseVoucherCodeId
                    ? _c("span", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-light btn-sm",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _setup.sendPaymentReminder(
                                  $event,
                                  booking.id
                                )
                              },
                            },
                          },
                          [_vm._v("Send")]
                        ),
                        _vm._v(" "),
                        booking.paymentReminderLastSent
                          ? _c("small", { staticClass: "text-nowrap" }, [
                              _vm._v(
                                _vm._s(
                                  _setup.getDate(
                                    booking.paymentReminderLastSent * 1000
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "span",
                    {
                      ref: "tooltipRefs",
                      refInFor: true,
                      style: {
                        color: booking.voucherPaymentConfirmed
                          ? "#5cb85c"
                          : "#ec971f",
                      },
                      attrs: {
                        title: booking.voucherPaymentConfirmed
                          ? "Voucher payment confirmed"
                          : "Voucher payment NOT confirmed",
                        "data-bs-toggle": "tooltip",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _setup.state.voucherCodeProviders[
                            booking.franchiseVoucherCodeId
                          ]
                        )
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  booking.voucherPaymentConfirmed
                    ? _c("span", [_vm._v("Confirmed")])
                    : booking.franchiseVoucherCodeId
                    ? _c("span", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-light btn-sm",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _setup.sendVoucherPaymentReminder(
                                  $event,
                                  booking.id
                                )
                              },
                            },
                          },
                          [_vm._v("Chase voucher")]
                        ),
                        _vm._v(" "),
                        booking.voucherPaymentReminderLastSent
                          ? _c("small", { staticClass: "text-nowrap" }, [
                              _vm._v(
                                _vm._s(
                                  _setup.getDate(
                                    booking.voucherPaymentReminderLastSent *
                                      1000
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _setup.showNotes(booking)
                        },
                      },
                    },
                    [
                      !booking.paymentNote
                        ? _c("i", { staticClass: "bi-pencil-square" })
                        : _vm._e(),
                      _vm._v(
                        "\n                    " +
                          _vm._s(booking.paymentNote) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _setup.hasArchiveAccess
                  ? _c("td", { staticClass: "text-end" }, [
                      _c("div", { staticClass: "dropdown" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-light btn-sm",
                            attrs: { "data-bs-toggle": "dropdown" },
                          },
                          [_vm._v("Action")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dropdown-menu dropdown-menu-end" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _setup.archiveBooking(booking.id)
                                  },
                                },
                              },
                              [_vm._v("Archive")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _setup.cancelBooking(booking.id)
                                  },
                                },
                              },
                              [_vm._v("Cancel and credit")]
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "my-3 py-3" }, [
      _c("h2", [_vm._v("Waiting list")]),
      _vm._v(" "),
      _setup.state.waitingListBookings.length
        ? _c("p", [
            _setup.hasArchiveAccess
              ? _c(
                  "button",
                  {
                    staticClass: "mb-2 btn btn-primary",
                    attrs: { disabled: _setup.isButtonDisabled(true) },
                    on: { click: _setup.archiveWaitListItems },
                  },
                  [_vm._v("Archive\n            ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "mb-2 btn btn-primary",
                attrs: { disabled: _setup.isButtonDisabled(true) },
                on: {
                  click: function ($event) {
                    return _setup.addMultipleToBookings($event)
                  },
                },
              },
              [_vm._v("Add to bookings\n            ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "mb-2 btn btn-primary",
                attrs: { disabled: _setup.isButtonDisabled(true) },
                on: { click: _setup.sendWaitListReminders },
              },
              [_vm._v("\n                Send reminder\n            ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "mb-2 btn btn-primary",
                class: { "btn-warning": _setup.state.parentsEmailSending },
                attrs: {
                  disabled:
                    _setup.isButtonDisabled(true) ||
                    _setup.state.parentsEmailSending,
                },
                on: {
                  click: function ($event) {
                    return _setup.sendParentsEmail(true)
                  },
                },
              },
              [_vm._v("Email parents\n            ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "mb-2 btn btn-primary",
                attrs: { disabled: _setup.isButtonDisabled(true) },
                on: {
                  click: function ($event) {
                    return _setup.openWorksheet(136, true, "Booking table")
                  },
                },
              },
              [_vm._v("Open booking table\n            ")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_setup.state.waitingListBookings.length
        ? _c("p", [_c("em", [_vm._v("empty")])])
        : _vm._e(),
      _vm._v(" "),
      _setup.state.waitingListBookings.length
        ? _c("table", { staticClass: "table table-condensed" }, [
            _c("thead", [
              _c("tr", [
                _c("td", [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: _setup.allWaitingListCheckboxesChecked,
                    },
                    on: {
                      click: function ($event) {
                        return _setup.selectAllCheckboxes(true)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("td"),
                _vm._v(" "),
                _c("td", [_vm._v("Child")]),
                _vm._v(" "),
                _c("td", [_vm._v("Parent")]),
                _vm._v(" "),
                _c("td", [_vm._v("Agreed price")]),
                _vm._v(" "),
                _c("td", [_vm._v("Booking reminder")]),
                _vm._v(" "),
                _c("td", [_vm._v("Voucher provider")]),
                _vm._v(" "),
                _c("td"),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(
                _setup.state.waitingListBookings,
                function (booking, index) {
                  return _c("tr", { key: booking.id }, [
                    _c("td", [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _setup.isChecked(booking.id, true),
                        },
                        on: {
                          click: function ($event) {
                            return _setup.toggleCheckbox(booking.id, true)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: { href: "" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _setup.goToBooking(booking.id, true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(index + 1))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _setup.state.waitingListChildNames[booking.childId]
                        ? _c(
                            "a",
                            {
                              attrs: { href: "" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _setup.goToChild(booking.childId)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _setup.state.waitingListChildNames[
                                    booking.childId
                                  ]
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _setup.state.waitingListParents[booking.childId]
                        ? _c("span", [
                            _c(
                              "a",
                              {
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _setup.goToParent(
                                      _setup.state.waitingListParents[
                                        booking.childId
                                      ].id
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _setup.state.waitingListParents[
                                      booking.childId
                                    ].firstName
                                  ) +
                                    " " +
                                    _vm._s(
                                      _setup.state.waitingListParents[
                                        booking.childId
                                      ].lastName
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              _vm._s(
                                _setup.state.waitingListParents[booking.childId]
                                  .email
                              ) + "\n                            "
                            ),
                            _c("br"),
                            _vm._v(
                              _vm._s(
                                _setup.state.waitingListParents[booking.childId]
                                  .telephone
                              ) + "\n                        "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_setup.formatCurrency(booking.agreedPrice))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light btn-sm",
                          on: {
                            click: function ($event) {
                              return _setup.sendWaitingListBookingReminder(
                                booking.id
                              )
                            },
                          },
                        },
                        [_vm._v("Send\n                    ")]
                      ),
                      _vm._v(" "),
                      booking.bookingNotificationLastSent
                        ? _c("small", [
                            _vm._v(
                              _vm._s(
                                _setup.getDate(
                                  booking.bookingNotificationLastSent * 1000
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _setup.state.voucherCodeProviders[
                            booking.franchiseVoucherCodeId
                          ]
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-end" }, [
                      _c("input", {
                        staticClass: "btn btn-light btn-sm",
                        attrs: { type: "button", value: "Add to bookings" },
                        on: {
                          click: function ($event) {
                            return _setup.addToBookings($event, booking.id)
                          },
                        },
                      }),
                    ]),
                  ])
                }
              ),
              0
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("h2", [_vm._v("New course dates email")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-light",
          attrs: {
            disabled:
              _setup.isButtonDisabled(false) && _setup.isButtonDisabled(true),
          },
          on: { click: _setup.sendNewCourseDatesEmail },
        },
        [_vm._v("Send\n        ")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "ms-3" }, [
        _vm._v("\n            Last sent: "),
        _setup.newCourseDatesEmailLastSent
          ? _c("strong", [
              _vm._v(
                _vm._s(
                  _setup.getDate(_setup.newCourseDatesEmailLastSent * 1000)
                )
              ),
            ])
          : _c("em", [_vm._v("never")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }